export default "__VITE_ASSET__vbqtqBA2BzbG9TS_Py1gsg__";